/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import styled from 'styled-components'
import ButtonShell from './ButtonShell'

const StyledButton = styled.div`
  background-color: ${(props) => props.theme.color.face.main};
  display: inline-block;
  border-radius: 30px;

  & > a,
  & > button {
    color: ${(props) => props.theme.color.text.light};
    padding: 7px 25px;
    width: 100%;
    height: 100%;
    display: block;
  }
`

const ButtonDefault = ({
  isAnchor,
  isCustom,
  to,
  children,
  className,
  target,
}) => (
  <StyledButton className={className}>
    {isCustom ? (
      children
    ) : (
      <ButtonShell to={to} isAnchor={isAnchor} target={target}>
        {children}
      </ButtonShell>
    )}
  </StyledButton>
)

export default ButtonDefault
